// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JRWSa9mNDCSZMyhTM8FQ{width:100px;height:100px;object-fit:contain}`, "",{"version":3,"sources":["webpack://./web/src/components/widgets/CartProduct/CartProduct.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA,CACA,YAAA,CACA,kBAAA","sourcesContent":[".productImage {\n  width: 100px;\n  height: 100px;\n  object-fit: contain;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productImage": `JRWSa9mNDCSZMyhTM8FQ`
};
export default ___CSS_LOADER_EXPORT___;
